import { Family, Parent, Student, FamilyMember, FamilyMemberRole, InviteStatus } from "../types/models";
import * as FamilyServiceImpl from "./familyServices/familyService";
import * as ParentService from "./familyServices/parentService";
import * as StudentService from "./familyServices/studentService";
import * as FamilyMemberService from "./familyServices/familyMemberService";
import { mapToInviteStatus } from "../utils/typeUtils";
import { supabase } from "@/lib/supabase";
import { toast } from "sonner";

export const FamilyService = {
  // Family methods
  getFamilies: FamilyServiceImpl.getFamilies,
  getFamily: FamilyServiceImpl.getFamily,
  getFamilyById: FamilyServiceImpl.getFamilyById,
  createFamily: FamilyServiceImpl.createFamily,
  updateFamily: FamilyServiceImpl.updateFamily,
  deleteFamily: FamilyServiceImpl.deleteFamily,
  setFamilyActiveStatus: FamilyServiceImpl.setFamilyActiveStatus,
  updateFamilyBillingStatus: FamilyServiceImpl.updateFamilyBillingStatus, // Add the new method here

  // Parent methods
  getAllParents: ParentService.getParentsByFamilyId,
  getParentsByFamily: ParentService.getParentsByFamilyId,
  addParent: ParentService.createParent,
  updateParent: ParentService.updateParent,
  deleteParent: ParentService.deleteParent,
  softDeleteParent: ParentService.softDeleteParent,
  toggleParentActiveStatus: ParentService.toggleParentActiveStatus,
  sendParentInvite: async (parentId: string) => {
    // Implement later if needed
    return true;
  },

  // Student methods
  getStudentsByFamily: StudentService.getStudentsByFamily,
  addStudent: StudentService.addStudent,

  // Family Member methods
  getFamilyMembers: FamilyMemberService.getFamilyMembers,
  addFamilyMember: FamilyMemberService.addFamilyMember,
  updateFamilyMember: FamilyMemberService.updateFamilyMember,
  deleteFamilyMember: FamilyMemberService.removeFamilyMember,
  sendFamilyMemberInvite: FamilyMemberService.sendFamilyMemberInvite,

  // Combined operations
  createFamilyWithParent: async (
    familyInput: Omit<Family, "id" | "created_at">,
    parentInput: Omit<Parent, "id" | "created_at" | "family_id">
  ): Promise<{ family: Family; parent: Parent }> => {
    try {
      console.log("Creating family:", familyInput);
      const family = await FamilyServiceImpl.createFamily({
        name: familyInput.name,
        organization_id: familyInput.organization_id,
        billing_status: familyInput.billing_status
      });
      
      if (!family) throw new Error("Failed to create family");
      
      console.log("Family created:", family);

      const parentWithFamily: Omit<Parent, "id" | "created_at"> = {
        ...parentInput,
        family_id: family.id,
        organization_id: family.organization_id,
        invite_status: parentInput.invite_status || 'pending',
        is_primary: parentInput.is_primary || false,
      };
      
      console.log("Creating parent:", parentWithFamily);
      const parent = await ParentService.createParent(parentWithFamily);
      
      if (!parent) throw new Error("Failed to create parent");
      
      console.log("Parent created:", parent);
      return { family, parent };
    } catch (error) {
      console.error("Error creating family with parent:", error);
      toast.error("Failed to create family with parent");
      throw error;
    }
  }
};
